import React from "react";
import SubHeader from "../../../common/subHeader";
import Divider from "../../../common/divider";
import RenderObjects from '../../../common/ObjectRenderer';

const DisputeModalDetailsSection = props => {
  let dispute = props.dispute;
  return (
    <div>
      <Divider />
      <SubHeader title="Details" />
      <Divider />
      <div className="row">
        <div className="col-md-6 dispute-col">
          <div>
            <label>Issuer:</label>
            <label>{dispute.issuer || "-"}</label>
          </div>
          <div>
            <label>Merchant:</label>
            <label>{dispute.merchant || "-"}</label>
          </div>         
          <div>
            <label>Merchant Reference:</label>
            <label>{dispute.merchantReference || "-"}</label>
          </div>
          <div>
            <label>Acquirer:</label>
            <label>{dispute.acquirer || "-"}</label>
          </div>
          <div>
            <label>Tran. Date:</label>
            <label>{dispute.transactionDate || "-"}</label>
          </div>

          <div>
            <label>Tran. Type:</label>
            <label>{dispute.transactionType || "-"}</label>
          </div>
          <div>
            <label>Tran. Amount:</label>
            <label>
              {dispute.transactionAmount ? `${dispute.transactionAmount}` : "-"}
            </label>
          </div>
          <div>
            <label>Scheme Amount :</label>
            <label>{dispute.schemeAmount || "-"}</label>
          </div>
          <div>
            <label>Settlement Amount :</label>
            <label>{dispute.settlementAmount || "-"}</label>
          </div>
          <div>
            <label>Tran. Ref.:</label>
            <label>{dispute.transactionReference || "-"}</label>
          </div>

          <div>
            <label>Customer Ref.:</label>
            <label className="break-all">
              {dispute.customerReference || "-"}
            </label>
          </div>
          <div>
            <label>Terminal Type:</label>
            <label>{dispute.terminalType || "-"}</label>
          </div>
          <div>
            <label>Surcharge Amount:</label>
            <label>
              {dispute.surchargeAmount ? `${dispute.surchargeAmount}` : "-"}
            </label>
          </div>
        </div>
        <div className="col-md-6 dispute-col">
          <div>
            <label>Log Code:</label>
            <label>{dispute.logCode || "-"}</label>
          </div>
          <div>
            <label>Reason:</label>
            <label>{dispute.reason || "-"}</label>
          </div>
          <div>
            <label>Category:</label>
            <label>{dispute.category || "-"}</label>
          </div>
          <div>
            <label>Status:</label>
            <label>{dispute.status || "-"}</label>
          </div>
          {dispute.statusScheduledEndDate && (
            <div>
              <label>Status Expires:</label>
              <label>{dispute.statusScheduledEndDate || "-"}</label>
            </div>
          )}
          <div>
            <label>Region:</label>
            <label>{dispute.region || "-"}</label>
          </div>
          <div>
            <label>Dispute Amount Type:</label>
            <label>{dispute.disputeAmountType || "-"}</label>
          </div>
          <div>
            <label>Dispute Amount:</label>
            <label>
              {dispute.disputeAmount ? `${dispute.disputeAmount}` : "-"}
            </label>
          </div>
          <div>
            <label>Created On:</label>
            <label>{dispute.createdOn || "-"}</label>
          </div>
          <div>
            <label>Additional Info :</label>
            <div className="panel panel-default additional-info-panel" style={{width: "100%"}}>
              <div className="panel-body">
                {
                  dispute.additionalInfo && 
                  <RenderObjects className="dispute-col" objectToConv={dispute.additionalInfo} />
                }
              </div>
            </div>
           {/*  <textarea
              readOnly="true"
              style={{ width: "400px", height: "100px", fontSize: "12px" }}
              value={JSON.stringify(dispute.additionalInfo, null, 2)}
            /> */}
          </div>
        </div>
      </div>
    </div>
  );
};
export default DisputeModalDetailsSection;



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/disputes/modal/disputesModalDetailsSection.js